export const environment = {
  production: true,
  API_SERVER: false
};
